import { render, staticRenderFns } from "./edit_profile.html?vue&type=template&id=98161c1e&scoped=true&"
import script from "./edit_profile.js?vue&type=script&lang=js&"
export * from "./edit_profile.js?vue&type=script&lang=js&"
import style0 from "./edit_profile.scss?vue&type=style&index=0&id=98161c1e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98161c1e",
  null
  
)

export default component.exports